import React from 'react';
//导入路由组件
import { HashRouter, Route, Routes, Router as HistoryRouter } from 'react-router-dom';
// import { Navigate } from 'react-router-dom';
import { createBrowserHistory } from "history";
import routes from "./routes";

const history = createBrowserHistory();

//路由配置文件
class Router extends React.Component{
    render() {
        return (
            // <HashRouter>
            <HistoryRouter location={history.location} navigator={history}>
                <Routes>
                    {/* <Route exact path="/路径" component={路由组件}></Route> */}
                    {/* <Route strict exact path="/路径/:自定义属性名" component={路由组件}></Route>   // 动态路由匹配   /路径/123  /路径/name */}
                    {
                        routes.map((item,index)=>{
                            return (
                                <Route key={index} exact={item.exact} path={item.path} element={item.component}></Route>
                            )
                        })
                    }
                    {/* <Route key={1} path={'/home'} exact element={App}></Route> */}
                    {/* <Route path='/cate' component={Cate}></Route> */}
                    {/* <Route path="/" element={<Navigate to ="/home" />}/> */}
                </Routes>
            </HistoryRouter>
            // </HashRouter>
        )
    }
};

export default Router;